document.addEventListener("DOMContentLoaded", () => {
      const input = document.getElementById("foot-length");
      const button = document.getElementById("calculate-size");
      const result = document.getElementById("size-result");
      const dataElement = document.getElementById("size-chart-data");

      if (!input || !button || !result || !dataElement) return;

      let sizeChart = [];
      try {
        sizeChart = JSON.parse(dataElement.textContent.trim());
      } catch (e) {
        console.error("Erro ao ler a tabela de tamanhos:", e, dataElement.textContent);
        result.textContent = "Erro ao carregar tabela de tamanhos.";
        return;
      }

      button.addEventListener("click", () => {
        const footLength = parseFloat(input.value);
        if (isNaN(footLength)) {
          result.textContent = "Por favor insira um número válido.";
          return;
        }

        const match = sizeChart.find(row => footLength >= row.min && footLength <= row.max);

        if (match) {
          result.textContent = `O tamanho ideal é: ${match.size}`;
        } else {
          result.textContent = "Não encontramos tamanho para esse valor.";
        }
      });
    });
